import { render, staticRenderFns } from "./ArchiveBarChart.vue?vue&type=template&id=24d4a518&scoped=true&"
import script from "./ArchiveBarChart.vue?vue&type=script&lang=js&"
export * from "./ArchiveBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveBarChart.vue?vue&type=style&index=0&id=24d4a518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d4a518",
  null
  
)

export default component.exports